export default "__VITE_ASSET__Cbzx08gj__"